import { defineStore } from 'pinia'
import http from '@/api/http'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    loading: false,
    bootstrapped: false,
    error: null,
  }),

  getters: {
    isAuthenticated: (s) => !!s.user,
    displayName: (s) => s.user?.name || s.user?.email || '',
  },

  actions: {
    async fetchMe() {
      this.loading = true
      this.error = null
      try {
        const { data } = await http.get('/auth/me')
        this.user = data?.data ?? data?.user ?? data ?? null
      } catch (e) {
        this.user = null
        if (e?.response?.status && e.response.status !== 401) {
          this.error = formatError(e)
        }
      } finally {
        this.loading = false
        this.bootstrapped = true
      }
      return this.user
    },

    async login({ email, password }) {
      this.loading = true
      this.error = null
      try {
        const { data } = await http.post('/auth/login', { email, password })
        this.user = data?.data ?? data?.user ?? data ?? null
        return true
      } catch (e) {
        this.error = formatError(e)
        return false
      } finally {
        this.loading = false
      }
    },

    async logout() {
      try {
        await http.post('/auth/logout')
      } catch (_) {
        // ignore
      } finally {
        this.user = null
      }
    },

    clear() {
      this.user = null
    },
  },
})

function formatError(e) {
  const r = e?.response?.data
  if (!r) return e?.message || 'Сетевая ошибка'
  if (typeof r === 'string') return r
  return r?.error?.message || r?.message || `HTTP ${e.response.status}`
}
